import React from 'react';
import TrendUpIcon from '@svg/trend-up.svg?react';
import TrendDownIcon from '@svg/trend-down.svg?react';
import './TrendPercentIndicator.scss';
import { formatPercentNumber } from '@src/utils/number-util';

interface TrendPercentIndicatorProps {
  trendPercent: number;
  trendLabel?: string;
  threshold?: number;
  showTrendDirectionText?: boolean;
}

const TrendPercentIndicator: React.FC<TrendPercentIndicatorProps> = ({
  trendPercent,
  trendLabel,
  threshold = 10,
  showTrendDirectionText = true,
}) => {

  const isOrange = Math.abs(trendPercent) > threshold;
  const trendDirection = trendPercent >= 0 ? 'up' : 'down';
  const className = isOrange ? 'trend-percent-indicator__icon--orange' : '';
  
  return (
    <div className="trend-percent-indicator">
      <span className="trend-percent-indicator-percent">
        {formatPercentNumber(Math.abs(trendPercent))}% {showTrendDirectionText ? trendDirection : ''}
      </span>
      {trendDirection === 'up' ? (
        <TrendUpIcon className={className} />
      ) : (
        <TrendDownIcon className={className}  />
      )}
      {trendLabel && <span>{trendLabel}</span>}
    </div>
  );
};

export default TrendPercentIndicator;
